import React, { useEffect, useState, useRef } from "react";
import List from "./claimList";
import Utils from "../../utility";
import { getClaimRecord } from "../../services/zbrainConnectorService";
import { keyConstants } from "../../constants";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

const ClaimListComponent = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const pageSize = 50;
  const [totalDoc, setTotalDoc] = useState(0);
  const totalPages = Math.ceil(totalDoc / pageSize);
  const [currentPage, setCurrentPage] = useState(
    Number(queryParams.get("page")) || 1
  );
  const [debounce, setDebouncedSearch] = useState(
    queryParams.get("search") || ""
  );
  const [versionScope, setVersionScope] = useState(
    queryParams.get("versionScope") || "Latest"
  );
  const topRef = useRef(null);
  const [resultFilter, setResultFilter] = useState(
    queryParams.get("result") || "All"
  );
  const [feedbackFilter, setFeedbackFilter] = useState(
    queryParams.get("feedback") || "All"
  );
  const [sort, setSort] = useState(queryParams.get("sort") || "processedOn");
  const [createdOnSortBy, setCreatedOnSortBy] = useState(
    queryParams.get("createdOnSort") || "desc"
  );
  const [processedOnSortBy, setProcessedOnSortBy] = useState(
    queryParams.get("processedOnSort") || "desc"
  );
  const [date, setDate] = useState({
    startDate: queryParams.get("fromDate") || null,
    endDate: queryParams.get("toDate") || null
  });
  const [selectTime, setSelectTime] = useState(
    queryParams.get("selectTime") || "All"
  );
  const [processedDate, setProcessedDate] = useState({
    startDate: queryParams.get("processedOnFrom") || null,
    endDate: queryParams.get("processedOnTo") || null
  });
  const [feedbackDate] = useState({
    startDate: queryParams.get("feedbackFromDate") || null,
    endDate: queryParams.get("feedbackToDate") || null
  });
  const [selectProcessedTime, setSelectProcessedTime] = useState(
    queryParams.get("processedTime") || "Last 14 days"
  );
  const [selectFeedbackTime] = useState(
    queryParams.get("feedbackTime") || null
  );
  const [versions, setVerisons] = useState([]);
  const [damageQuestionText, setDamageQuestionText] = useState(
    queryParams.get("damageQuestionText") || "All"
  );
  const [selectedVersion, setSelectedVersion] = useState(
    queryParams.get("v") || "All"
  );
  const value = queryParams.get("damageQuestionText");

  const [selectedDamage, setSelectedDamage] = useState(
    value ? JSON.parse(value) : []
  );
  const controllerRef = useRef(null);

  const getDateRange = (label) => {
    const now = new Date();
    switch (label) {
      case "Last 14 days":
        return {
          startDate: Utils.formatDateYear(
            new Date(now - 13 * 24 * 60 * 60 * 1000)
          ),
          endDate: Utils.formatDateYear(now)
        };
      case "Previous month": {
        const firstDayOfMonth = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        );
        const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        return {
          startDate: Utils.formatDateYear(firstDayOfMonth),
          endDate: Utils.formatDateYear(lastDayOfMonth)
        };
      }

      default:
        return null;
    }
  };

  const getDateRangeProcessed = (label) => {
    const now = new Date();

    const startOfDayUTC = (date) => {
      return Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
        0
      );
    };

    const endOfDayUTC = (date) => {
      return Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
        999
      );
    };

    switch (label) {
      case "Last 7 days":
        return {
          startDate: startOfDayUTC(
            new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000)
          ),
          endDate: endOfDayUTC(now)
        };
      case "Last 14 days":
        return {
          startDate: startOfDayUTC(
            new Date(now.getTime() - 13 * 24 * 60 * 60 * 1000)
          ),
          endDate: endOfDayUTC(now)
        };
      case "Previous month": {
        const firstDayOfMonth = new Date(
          now.getUTCFullYear(),
          now.getUTCMonth() - 1,
          1
        );
        const lastDayOfMonth = new Date(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          0
        );
        return {
          startDate: startOfDayUTC(firstDayOfMonth),
          endDate: endOfDayUTC(lastDayOfMonth)
        };
      }
      default:
        return null;
    }
  };

  const getClaims = async () => {
    if (controllerRef.current) {
      controllerRef.current.abort(); // cancel previous request
    }
    controllerRef.current = new AbortController();
    try {
      let requesData = {
        claimNumber: debounce,
        limit: pageSize,
        page: currentPage
      };

      const questionText = queryParams.get("questionText");
      const reportFeedback = queryParams.get("reportFeedback");
      const feedbackType = queryParams.get("feedbackType");
      const slaCompliance = queryParams.get("slaCompliance");

      if (selectedVersion !== "All") {
        requesData.version = Number(selectedVersion.slice(1));
      }
      if (versionScope) {
        requesData.versionScope =
          versionScope === "Latest"
            ? "latest"
            : versionScope === "All"
              ? "all"
              : versionScope;
      }

      if (questionText) {
        requesData.questionText = questionText;
      }

      if (reportFeedback) {
        requesData.reportFeedback = reportFeedback;
      }
      if (feedbackType) {
        requesData.feedbackType = feedbackType;
      }
      if (slaCompliance) {
        requesData.slaCompliance = slaCompliance;
      }

      if (selectedDamage) {
        const selectedKeys = Object.keys(selectedDamage).filter(
          (key) => selectedDamage[key] === true
        );
        requesData.damageQuestionText = selectedKeys;
      }

      if (sort === "processedOn") {
        requesData.processedOnSortBy = processedOnSortBy;
      } else {
        requesData.createdOnSortBy = createdOnSortBy;
      }

      let highestVersionArray = [];
      if (selectTime !== "Custom" && selectTime !== "All") {
        const { startDate, endDate } = getDateRange(selectTime);
        requesData.fromDate = startDate;
        requesData.toDate = endDate;
      }
      if (date.startDate && date.endDate && selectTime === "Custom") {
        requesData.fromDate = date.startDate;
        requesData.toDate = date.endDate;
      }
      if (
        selectProcessedTime !== "Custom" &&
        selectProcessedTime !== "All" &&
        !debounce
      ) {
        const { startDate, endDate } =
          getDateRangeProcessed(selectProcessedTime);
        requesData.processedOnFrom = startDate;
        requesData.processedOnTo = endDate;
      }
      if (
        selectFeedbackTime !== "Custom" &&
        selectFeedbackTime !== "All" &&
        selectFeedbackTime !== null
      ) {
        const { startDate, endDate } =
          getDateRangeProcessed(selectFeedbackTime);

        requesData.feedbackFromDate = startDate;
        requesData.feedbackToDate = endDate;
      }
      if (
        processedDate.startDate &&
        processedDate.endDate &&
        selectProcessedTime === "Custom" &&
        !debounce
      ) {
        const startDateObject = new Date(
          processedDate.startDate.split("-").reverse().join("-")
        );
        const startUTCDate = Date.UTC(
          startDateObject.getUTCFullYear(),
          startDateObject.getUTCMonth(),
          startDateObject.getUTCDate(),
          0,
          0,
          0,
          0
        );
        requesData.processedOnFrom = startUTCDate;
        let endDateObject = new Date(
          processedDate.endDate.split("-").reverse().join("-")
        );
        const endUTCDate = Date.UTC(
          endDateObject.getUTCFullYear(),
          endDateObject.getUTCMonth(),
          endDateObject.getUTCDate(),
          23,
          59,
          59,
          999
        );

        requesData.processedOnTo = endUTCDate;
      }
      if (
        feedbackDate.startDate &&
        feedbackDate.endDate &&
        selectFeedbackTime === "Custom"
      ) {
        const startDateObject = new Date(
          feedbackDate.startDate.split("-").reverse().join("-")
        );
        const startUTCDate = Date.UTC(
          startDateObject.getUTCFullYear(),
          startDateObject.getUTCMonth(),
          startDateObject.getUTCDate(),
          0,
          0,
          0,
          0
        );
        requesData.feedbackFromDate = startUTCDate;
        let endDateObject = new Date(
          feedbackDate.endDate.split("-").reverse().join("-")
        );
        const endUTCDate = Date.UTC(
          endDateObject.getUTCFullYear(),
          endDateObject.getUTCMonth(),
          endDateObject.getUTCDate(),
          23,
          59,
          59,
          999
        );

        requesData.feedbackToDate = endUTCDate;
      }

      if (feedbackFilter !== "All") {
        requesData.feedback =
          feedbackFilter === "Correct"
            ? keyConstants.CORRECT
            : feedbackFilter === "Correct (As Per Input & Rules)"
              ? keyConstants.GEN_AI_CORRECT_INSUFFICIENT_INPUTS
              : feedbackFilter === "Incorrect AI response"
                ? keyConstants.INCORRECT_AI_RESPONSE
                : keyConstants.INCORRECT_DATA_IMAGE;
      }
      if (resultFilter !== "All") {
        requesData.processingStatus = resultFilter;
      }
      setLoading(true);
      const signal = controllerRef.current.signal;
      const [error, response] = await Utils.parseResponse(
        getClaimRecord(requesData, signal)
      );

      if (error || !response) {
        if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else {
          toast.error(error?.response?.data?.message);
        }
        return;
      }
      for (let i = 1; i <= response.highestVersion; i++) {
        highestVersionArray.push(`v${i}`);
      }
      setVerisons(highestVersionArray);
      setTotalDoc(response.totalDocuments);

      setList(response?.claims);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      scrollToTop();
    }
  };
  const handleFirstPage = () => {
    handlePageChange(1);
    scrollToTop();
  };

  const handleLastPage = () => {
    handlePageChange(totalPages);
    scrollToTop();
  };

  const updateQueryParams = (key, value) => {
    if (value) {
      queryParams.set(key, value);
    } else {
      queryParams.delete(key);
    }
  };

  const updateDateParams = () => {
    if (
      date?.endDate !== null &&
      date?.startDate !== null &&
      selectTime === "Custom"
    ) {
      queryParams.set("toDate", date.endDate);
      queryParams.set("fromDate", date.startDate);
    } else {
      queryParams.delete("toDate");
      queryParams.delete("fromDate");
    }
  };
  const updateProcessedParams = () => {
    if (
      processedDate?.endDate !== null &&
      processedDate?.startDate !== null &&
      selectProcessedTime === "Custom"
    ) {
      queryParams.set("processedOnFrom", processedDate.startDate);
      queryParams.set("processedOnTo", processedDate.endDate);
    } else {
      queryParams.delete("processedOnTo");
      queryParams.delete("processedOnFrom");
    }
  };

  const updateFeedbackParams = () => {
    if (
      feedbackDate?.endDate !== null &&
      feedbackDate?.startDate !== null &&
      selectFeedbackTime === "Custom"
    ) {
      queryParams.set("feedbackFromDate", feedbackDate?.startDate);
      queryParams.set("feedbackToDate", feedbackDate?.endDate);
    } else {
      queryParams.delete("feedbackToDate");
      queryParams.delete("feedbackFromDate");
    }
  };

  const toggleParent = (parent) => {
    setSelectedDamage((prev) => {
      const updated = { ...prev };
      const allChildren = parent.children.map((c) => c.value);
      const areAllSelected = allChildren.every((c) => prev[c]);

      allChildren.forEach((c) => {
        updated[c] = !areAllSelected;
      });

      return updated;
    });
  };

  const toggleChild = (child) => {
    setSelectedDamage((prev) => ({
      ...prev,
      [child.value]: !prev[child.value]
    }));
  };

  useEffect(() => {
    if (
      (selectProcessedTime === "Custom" &&
        processedDate.endDate &&
        processedDate.startDate) ||
      selectProcessedTime !== "Custom"
    ) {
      getClaims();
    }

    updateQueryParams("result", resultFilter);
    updateQueryParams("page", currentPage);
    updateQueryParams("v", selectedVersion);
    updateQueryParams("versionScope", versionScope);
    updateQueryParams("feedback", feedbackFilter);
    updateDateParams();
    queryParams.set("selectTime", selectTime);
    updateProcessedParams();
    queryParams.set("processedTime", selectProcessedTime);
    queryParams.set("damageQuestionText", JSON.stringify(selectedDamage));
    updateFeedbackParams();
    if (selectFeedbackTime !== null) {
      queryParams.set("feedbackTime", selectFeedbackTime);
    }
    queryParams.set("sort", sort);
    queryParams.set("processedOnSort", processedOnSortBy);
    queryParams.set("createdOnSort", createdOnSortBy);
    if (debounce) {
      queryParams.set("search", debounce);
    } else {
      queryParams.delete("search");
    }
    navigate(
      {
        search: queryParams.toString()
      },
      { replace: true }
    );
    // eslint-disable-next-line
  }, [
    debounce,
    currentPage,
    resultFilter,
    feedbackFilter,
    selectTime,
    date,
    createdOnSortBy,
    selectedVersion,
    selectProcessedTime,
    processedDate,
    processedOnSortBy,
    selectFeedbackTime,
    feedbackDate,
    damageQuestionText,
    selectedDamage,
    versionScope
  ]);

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem("scrollPosition");
    if (savedScrollPosition && topRef.current) {
      topRef.current.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  });

  return (
    <div className="h-full">
      <List
        loading={loading}
        list={list}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleFirstPage={handleFirstPage}
        handleLastPage={handleLastPage}
        setDebouncedSearch={setDebouncedSearch}
        debounce={debounce}
        resultFilter={resultFilter}
        setResultFilter={setResultFilter}
        feedbackFilter={feedbackFilter}
        setFeedbackFilter={setFeedbackFilter}
        setDate={setDate}
        date={date}
        setSelectTime={setSelectTime}
        selectTime={selectTime}
        setCreatedOnSortBy={setCreatedOnSortBy}
        createdOnSortBy={createdOnSortBy}
        setProcessedOnSortBy={setProcessedOnSortBy}
        processedOnSortBy={processedOnSortBy}
        topRef={topRef}
        setCurrentPage={setCurrentPage}
        versions={versions}
        setSelectedVersion={setSelectedVersion}
        selectedVersion={selectedVersion}
        versionScope={versionScope}
        setVersionScope={setVersionScope}
        processedDate={processedDate}
        setProcessedDate={setProcessedDate}
        selectProcessedTime={selectProcessedTime}
        setSelectProcessedTime={setSelectProcessedTime}
        setDamageQuestionText={setDamageQuestionText}
        damageQuestionText={damageQuestionText}
        toggleChild={toggleChild}
        toggleParent={toggleParent}
        selectedDamage={selectedDamage}
        setSelectedDamage={setSelectedDamage}
        sort={sort}
        setSort={setSort}
      />
    </div>
  );
};

export default ClaimListComponent;
